export const umbracoImageLoader = ({ src, width }: { src: string; width: number }) => {
  let url: URL;
  try {
    url = new URL(src);
  } catch {
    return src;
  }

  url.searchParams.set('rmode', 'max');
  url.searchParams.set('width', String(width));
  url.searchParams.delete('height');
  return url.toString();
};

// For a fixed-height, object-fit: cover box: requesting by width under-resolves
// whenever the source image is proportionally wider than the box.
export const umbracoImageLoaderByHeight = ({ src, height }: { src: string; height: number }) => {
  let url: URL;
  try {
    url = new URL(src);
  } catch {
    return src;
  }

  url.searchParams.set('rmode', 'max');
  url.searchParams.set('height', String(height));
  url.searchParams.delete('width');
  return url.toString();
};
